import { render, staticRenderFns } from "./PlaceholderView.vue?vue&type=template&id=2648bd6d&scoped=true"
import script from "./PlaceholderView.vue?vue&type=script&lang=js"
export * from "./PlaceholderView.vue?vue&type=script&lang=js"
import style0 from "./PlaceholderView.vue?vue&type=style&index=0&id=2648bd6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648bd6d",
  null
  
)

export default component.exports